'use client';
import { Box, IconButtonProps } from '@mui/material';
import { StyledIconButton } from './styles';

interface Props extends IconButtonProps {
    readonly icon: React.ReactNode;
}

const IconButton = (props: Props) => {
    const { icon, ...buttonProps } = props;

    return (
        <Box p={0.5}>
            <StyledIconButton {...buttonProps}>{icon}</StyledIconButton>
        </Box>
    );
};

export { IconButton };
